import P from 'prop-types';
import { useState } from 'react';

export const MontarCarga = ({ carga, inicializa }) => {
  const [check, setCheck] = useState(false);

  return (
    <>
      <button
        type="button"
        className="btn btn-outline-success"
        data-bs-toggle="modal"
        data-bs-target={`#montarCargaModal${carga.cod_carga}`}
      >
        Montar
      </button>

      <div
        className="modal fade"
        id={`montarCargaModal${carga.cod_carga}`}
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Carga - {carga.cod_carga}
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setCheck(false)}
              ></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-6">
                  <label className="form-label">N° Carga</label>
                  <input
                    onChange={() => 0}
                    type="text"
                    className="form-control"
                    aria-label="Text input with dropdown button"
                    value={carga.cod_carga}
                  />
                </div>
                <div className="col-6">
                  <label className="form-label">Transportadora</label>
                  <input
                    onChange={() => 0}
                    type="text"
                    className="form-control"
                    aria-label="Text input with dropdown button"
                    value={carga.cod_transportador}
                  />
                </div>
                <div className="col-12">
                  <label className="form-label">Empresa</label>
                  <input
                    onChange={() => 0}
                    type="text"
                    className="form-control mb-3"
                    aria-label="Text input with dropdown button"
                    value={
                      carga.cod_empresa == 1000
                        ? 'SR Embalagens Barretos'
                        : carga.cod_empresa == 1100
                        ? 'SR Embalagens Três Rios'
                        : carga.cod_empresa == 2000
                        ? 'Barreflex Barretos'
                        : carga.cod_empresa == 2100
                        ? 'Barreflex Sumaré'
                        : ''
                    }
                  />
                  <label className="form-label">Cliente</label>
                  <input
                    onChange={() => 0}
                    type="text"
                    className="form-control mb-3"
                    aria-label="Text input with dropdown button"
                    value={carga.nome_cliente}
                  />

                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                      checked={check}
                      onClick={() => setCheck((e) => !e)}
                    />
                    <label className="form-check-label" htmlFor="flexCheckDefault">
                      Autorizo a carga a ser montada
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline-success"
                onClick={() => inicializa(carga)}
                data-bs-dismiss="modal"
                disabled={!check}
              >
                Montar Carga
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

MontarCarga.propTypes = {
  carga: P.obj,
  inicializa: P.func,
};
